import axios from "axios";
import { SUBSCRIBE_URL } from "../utils";

export type SubscribeData = { email?: string; accountType?: string };

export const subscribe = async (subscribeData: SubscribeData) => {
  return await axios.post(SUBSCRIBE_URL, subscribeData);
};
